/**
 * O texto da primeira opção de um `CampoSelecao` que escolhe um cadastro.
 *
 * Nasceu do achado do QAS (20/10/2026): várias janelas pediam o identificador
 * interno da pessoa, da máquina, do contrato… num campo de texto. Agora elas
 * escolhem da lista, e a lista tem as mesmas situações em toda janela — o
 * perfil não lê aquela lista, ela não chegou, ela está chegando, ela veio
 * vazia, ou veio — e cada uma diz o que fazer (p.22).
 */
export function rotuloDaEscolha({
  consulta,
  pode,
  quantas,
  escolha,
  nenhuma,
  semPermissao,
}: {
  readonly consulta: { readonly isPending: boolean; readonly isError: boolean };
  /** O perfil lê a lista? Sem a licença, a janela nem pergunta. */
  readonly pode: boolean;
  readonly quantas: number;
  /** "Escolha a pessoa", ou a opção vazia de um campo opcional. */
  readonly escolha: string;
  /** "Nenhuma pessoa em uso · cadastre em Cadastros › Pessoas". */
  readonly nenhuma: string;
  /** "O seu perfil não lê a lista de pessoas · peça a liberação em Cadastros › Governança". */
  readonly semPermissao: string;
}): string {
  if (!pode) return semPermissao;
  if (consulta.isError) return 'A lista não carregou · feche e abra a janela de novo';
  if (consulta.isPending) return 'Carregando a lista…';
  return quantas === 0 ? nenhuma : escolha;
}
